import React from "react";
import PropTypes from "prop-types";
import RSButtonGroup from "reactstrap/lib/ButtonGroup";
import Button from "reactstrap/lib/Button";

import {
  gatherClasses,
  gatherConditionalProps,
  isFunction
} from "../../lib/utils";

import "./buttonGroup.scss";

const ButtonGroup = props => {
  const {
    dataTestId,
    block,
    items,
    disabledItems,
    selectedItems,
    onItemClick
  } = props;
  return (
    <RSButtonGroup
      data-testid={dataTestId}
      className={gatherClasses(props, block ? "oui-d-flex" : null)}
      {...gatherConditionalProps(props, "size")}
    >
      {items.map((btn, index) => {
        const isDisabled = disabledItems.includes(btn.name) || btn.disabled;
        const isSelected = selectedItems.includes(btn.name) || btn.isSelected;
        return (
          <Button
            key={index}
            outline={!(isDisabled && isSelected)}
            color="primary"
            disabled={isDisabled}
            active={isSelected}
            onClick={event => {
              if (isFunction(btn.onClick)) {
                btn.onClick(event);
              }
              if (isFunction(onItemClick)) {
                onItemClick(event, btn);
              }
            }}
            name={btn.name}
          >
            {btn.label}
          </Button>
        );
      })}
    </RSButtonGroup>
  );
};

ButtonGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isSelected: PropTypes.bool,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
      name: PropTypes.string
    })
  ).isRequired,
  size: PropTypes.oneOf(["lg", "md", "sm"]),
  block: PropTypes.bool,
  className: PropTypes.string,
  onItemClick: PropTypes.func,
  disabledItems: PropTypes.arrayOf(PropTypes.string),
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  dataTestId: PropTypes.string
};

ButtonGroup.defaultProps = {
  size: "sm",
  block: false,
  disabledItems: [],
  selectedItems: [],
  dataTestId: "orion-button-group"
};

ButtonGroup.displayName = "OrionButtonGroup";

export default ButtonGroup;
